var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.data),function(cell){return _c('table-td',{key:cell,attrs:{"content":cell}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }